import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { initializeApp } from 'firebase/app'
import { getFirestore } from 'firebase/firestore'

// Firebase Configuration
const firebaseConfig = {
  apiKey: 'AIzaSyD1h-LDX7JBykD2dnVAK9QKjtQQy0qW6jw',
  authDomain: 'relatos-mitos-y-leyendas.firebaseapp.com',
  projectId: 'relatos-mitos-y-leyendas',
  storageBucket: 'relatos-mitos-y-leyendas.appspot.com',
  messagingSenderId: '204244421579',
  appId: '1:204244421579:web:c8598c9f040eb7c505844e',
  measurementId: 'G-K4HZ1JKEZ3'
}

// Initialize Firebase
initializeApp(firebaseConfig)
const db = getFirestore()

// Create Vue app
const app = createApp(App)
app.use(router)
app.mount('#app')

export {
  db
}